import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthService } from './auth.service';
import { Role } from './roles';

@Directive({
  selector: '[appHasRole]',
})
export class HasRole {
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly authService = inject(AuthService);

  readonly roles = input.required<Role | readonly Role[]>({ alias: 'appHasRole' });

  private rendered = false;

  constructor() {
    effect(() => {
      const required = this.roles();
      const requiredRoles = Array.isArray(required) ? required : [required];
      const allowed = requiredRoles.some((role) => this.authService.hasRole(role));
      this.updateView(allowed);
    });
  }

  private updateView(allowed: boolean): void {
    if (allowed && !this.rendered) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.rendered = true;
    } else if (!allowed && this.rendered) {
      this.viewContainer.clear();
      this.rendered = false;
    }
  }
}
